import React, {useState, useEffect, useRef, useCallback, createRef} from "react";
import {inject, observer} from 'mobx-react';
import {db} from '../../../../firebase/Firebase';
import DataGrid, {
    Column,
    Button,
    Pager,
    Paging,
    Export,
    SearchPanel,
    Sorting, Editing,
} from 'devextreme-react/data-grid';
import {useSnackbar} from 'notistack';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import {exportDataGrid} from 'devextreme/excel_exporter';
import format from 'date-fns/format'
import {es} from "date-fns/locale";
import axios from "axios"
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import {jsPDF} from "jspdf";
import {exportDataGrid as exportDataGridToPdf} from "devextreme/pdf_exporter";
import VerticalSpace from "../../../../palette/VerticalSpace";
import {Animated} from "react-animated-css";
import {FormContainer, LayoutChild} from "../../../../palette/Palette";
import HeaderPage from "../../../../palette/HeaderPage";
import ComponentLoadPanel from "../../../../palette/LoadPanel";
import Alerts from "../../../../palette/Alerts";
import {Popup, Position, ToolbarItem} from 'devextreme-react/popup';
import BookingManagamentDetail from "./BookingManagamentDetail";
import {FilterDelete} from "../../../../utils/HelpFunctions";
import ExpressBookingDetail from "./ExpressBookingDetail";

const date = new Date();

const datesObject = {
    since: null,
    until: null
}

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
};

const url = 'https://booking-history-easi4xatjq-uc.a.run.app/booking-history';

//const url = 'http://127.0.0.1:5000/booking-history';

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function BookingHistory(props) {

    const {DataStore} = props;

    const {companyName, idCompany} = DataStore

    const [bookings, setBookings] = useState(null)
    const [dates, setDates] = useState(datesObject);
    const [datesStr, setDatesStr] = useState(datesObject);
    const [showPanel, setShowPanel] = useState(false);
    const [textPanel, setTextPanel] = useState('Consultando. . .');
    const [textGrid, setTextGrid] = useState('Esperando datos...');
    const [dataRow, setDataRow] = useState(null);
    const [trigger, setTrigger] = useState(false)
    const [triggerEffect, setTriggerEffect] = useState(false)
    const [loading, setLoading] = useState(false)
    const [popupVisible, setPopupVisible] = React.useState(false);
    const [popupVisibleExpress, setPopupVisibleExpress] = React.useState(false);

    const {enqueueSnackbar} = useSnackbar();
    const isMounted = useMountedState()
    const dataGridRef = createRef();

    const year = format(date, 'yyyy');
    const month = format(date, 'MMMM', {locale: es});
    const upperMonth = month.charAt(0).toUpperCase() + month.slice(1)

    const mainPath = db.collection(companyName).doc(idCompany).collection('BookingHistory')

    useEffect(() => {
        const GetBookingHistory = async () => {
            let ID = 0
            await mainPath.doc(year).collection(month).onSnapshot(querySnapshot => {
                const dataArray = []
                querySnapshot.forEach(doc => {
                    ID = ID + 1
                    let paymentValue = parseFloat(doc.data().paymentValue)
                    const obj = {...doc.data(), docId: doc.id, ID: ID, paymentValue: paymentValue};
                    dataArray.push(obj);
                })
                const f = FilterDelete(dataArray, 'status', 'Cancelado')
                const filterResult = FilterDelete(f, 'status', 'Semi completado')
                const orderArray = filterResult.sort((a, b) => (a['status'] < b['status']) ? 1 : -1)
                setBookings([...orderArray])
                setLoading(true)
            })
        }

        if (isMounted()) {
            GetBookingHistory().catch(() => {
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
            })
        }
    }, [isMounted, trigger])

    const onValueChanged = async (value, key) => {
        if (value) {
            setTextPanel('Consultando . . .')
            const date = format(value, 'yyyy-MM-dd')
            setDates({...dates, [key]: value})
            setDatesStr({...datesStr, [key]: date})
            const search = {...datesStr, [key]: date}

            if (search.until && search.since) {
                if (search.until < search.since) {
                    NotiStackInfo('La fecha final no puede ser anterior a la fecha actual', 'error',
                        enqueueSnackbar)
                    return
                }

                setShowPanel(true)
                setTimeout(() => setTextPanel('Espere un momento . . .'), 4000)

                const dateSince = Date.parse(search.since)
                const dateUntil = Date.parse(search.until)

                const yearSince = format(dateSince, 'yyyy')
                const yearUntil = format(dateUntil, 'yyyy')

                if (yearSince === yearUntil) {
                    const data = {
                        search,
                        companyName: companyName,
                        idCompany: idCompany,
                        sameYear: true
                    }

                    await axios.post(url, data, {headers: headers})
                        .then(res => {
                            setBookings(res.data.result)
                            res.data.result.length === 0 && setTextGrid('No existe historial para estas fechas...')
                            setShowPanel(false)
                            setTextPanel('Consultando . . .')
                        }).catch(() => {
                            setBookings([])
                            setShowPanel(false)
                            setTextPanel('Consultando . . .')
                            NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                        })

                } else {
                    const data = {
                        search,
                        companyName: companyName,
                        idCompany: idCompany,
                        sameYear: false
                    }
                    await axios.post(url, data, {headers: headers})
                        .then(res => {
                            setBookings(res.data.result)
                            res.data.result.length === 0 && setTextGrid('No existe historial para estas fechas...')
                            setShowPanel(false)
                            setTextPanel('Consultando . . .')
                        }).catch(() => {
                            setBookings([])
                            setShowPanel(false)
                            setTextPanel('Consultando . . .')
                            NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                        })
                }
            }
        }
        if (value == null) {
            setTrigger(!trigger)
            setDates(datesObject)
        }
    }

    const onToolbarPreparing = (e) => {

        const {toolbarOptions} = e
        const {items} = toolbarOptions

        items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                width: 120,
                text: 'Imprimir',
                elementAttr: {id: 'btn-pdf'},
                icon: 'far fa-file-pdf',
                onClick: exportGridPDF
            }
        })

        items.unshift({
                location: 'before',
                widget: 'dxDateBox',
                options: {
                    width: 212,
                    placeholder: 'Hasta',
                    showClearButton: true,
                    value: dates.until,
                    onValueChanged: (e) => onValueChanged(e.value, 'until')
                }
            },
        )

        items.unshift({
                location: 'before',
                widget: 'dxDateBox',
                options: {
                    width: 212,
                    placeholder: 'Desde',
                    showClearButton: true,
                    value: dates.since,
                    onValueChanged: (e) => onValueChanged(e.value, 'since')
                }
            },
        )
    }

    function exportGridPDF() {
        const pdfDoc = new jsPDF('l', 'pt', "a4");
        const dataGrid = dataGridRef.current.instance;

        const options = {
            jsPDFDocument: pdfDoc,
            component: dataGrid,
            autoTableOptions: {
                margin: {top: 60, left: 15}
            },
        }

        exportDataGridToPdf(options).then(() => {
            pdfDoc.setFontSize(12);
            const pageCount = pdfDoc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                pdfDoc.setPage(i);
                const pageSize = pdfDoc.internal.pageSize;
                const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
                const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                const header = companyName;
                const report = `Reporte : Historial de reservas`
                const date = `Fecha : ${format(new Date(), 'yyyy-MM-dd')}`
                const footer = `Pagina ${i} de ${pageCount}`;

                // Header
                pdfDoc.setFontSize(14)
                pdfDoc.setFont('helvetica', '', 'bold')
                pdfDoc.text(header, 15, 15, {baseline: 'top'});
                pdfDoc.setFontSize(12)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(report, 15, 30, {baseline: 'top'});
                pdfDoc.setFontSize(8)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(date, 15, 45, {baseline: 'top'});
                // Footer
                pdfDoc.setFontSize(8)
                pdfDoc.text(footer, pageWidth / 2 - (pdfDoc.getTextWidth(footer) / 2), pageHeight - 15, {baseline: 'bottom'});

            }
        }).then(() => {
            pdfDoc.save('Gestión-reservas.pdf');
        });
    }

    const onRowUpdating = (e) => {
        console.log(e.row.data)
        if(e.row.data.type !== 'EX'){
            setDataRow(e.row.data);
            setPopupVisible(true);
            setTriggerEffect(!triggerEffect);
        }else{
            setDataRow(e.row.data);
            setPopupVisibleExpress(true);
            setTriggerEffect(!triggerEffect);
        }
    };

    const onExporting = (e) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
            autoFilterEnabled: true,
            topLeftCell: {row: 6, column: 2},
            customizeCell: ({gridCell, excelCell}) => {

                if (gridCell.rowType === 'data') {
                    if (excelCell.row % 2 === 0) {
                        excelCell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: {argb: 'C6EFCE'},
                            bgColor: {argb: 'C6EFCE'},
                        };
                    }
                }
            },
        }).then(function () {
            const headerCompany = worksheet.getRow(2);
            const headerReport = worksheet.getRow(3);
            const headerDate = worksheet.getRow(4);

            headerCompany.getCell(2).value = companyName;
            headerCompany.getCell(2).font = {bold: true, size: 16, underline: 'double'};

            headerReport.getCell(2).value = `Reporte : Gestión de reservas`;
            headerReport.getCell(2).font = {name: 'Segoe UI Light', size: 12, bold: 600};
            headerReport.getCell(2).alignment = {horizontal: 'left'};

            headerDate.getCell(2).value = `Fecha : ${format(new Date(), 'yyyy-MM-dd')}`;
            headerDate.getCell(2).font = {name: 'Segoe UI Light', size: 8, bold: 700};
            headerDate.getCell(2).alignment = {horizontal: 'left'};

            workbook.xlsx.writeBuffer().then(function (buffer) {
                saveAs(new Blob([buffer], {type: 'application/octet-stream'}), 'Gestión-reservas.xlsx');
            });
        });
        e.cancel = true;
    };

    const hideInfo = () => {
        setPopupVisible(false)
        setPopupVisibleExpress(false)
    }

    return (
        <>
            <VerticalSpace space={30}/>
            <Popup
                visible={popupVisible}
                onHiding={hideInfo}
                dragEnabled={false}
                closeOnOutsideClick={false}
                showCloseButton={false}
                showTitle={true}
                position={'top'}
                title="Detalles de reserva"
                container=".dx-viewport"
                width={390}
                height={'auto'}
            >
                <div>
                    {dataRow &&
                    <BookingManagamentDetail setVisible={setPopupVisible} dataRow={dataRow} companyName={companyName}
                                             idCompany={idCompany} setTrigger={setTrigger} trigger={trigger}
                                             triggerEffect={triggerEffect}/>}
                </div>
            </Popup>


            <Popup
                visible={popupVisibleExpress}
                onHiding={hideInfo}
                dragEnabled={false}
                closeOnOutsideClick={false}
                showCloseButton={false}
                showTitle={true}
                title="Detalles de reserva"
                container=".dx-viewport"
                width={390}
                height={'auto'}
            >
                <div>
                    {dataRow &&
                    <ExpressBookingDetail setVisible={setPopupVisibleExpress} dataRow={dataRow} companyName={companyName}
                                          idCompany={idCompany} setTrigger={setTrigger} trigger={trigger}
                                          triggerEffect={triggerEffect}/>}
                </div>
            </Popup>


            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={true}>
                <div className="grid-container">
                    <HeaderPage icon={'far fa-folder'} text={'Gestión de reservas'} load={loading}
                                textLoad={'Cargando....'}/>
                    <FormContainer>
                        <DataGrid
                            id="types-vehicles"
                            ref={dataGridRef}
                            dataSource={bookings}
                            keyExpr="ID"
                            allowColumnReordering={true}
                            showBorders={true}
                            onToolbarPreparing={onToolbarPreparing}
                            rowAlternationEnabled={true}
                            noDataText={textGrid}
                            onExporting={onExporting}
                        >
                            <SearchPanel visible={true}
                                         width={240}
                                         placeholder="Buscar"/>
                            <Export enabled={true} texts={{exportAll: 'Excel'}}/>
                            <Sorting mode="multiple"/>
                            <Paging defaultPageSize={20}/>
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={[10, 20, 30]}
                                showInfo={true}/>
                            <Editing
                                mode="row"
                                texts={{
                                    editRow: 'Detalles',
                                }}
                                useIcons={true}
                                allowUpdating={true}
                            />
                            <Column dataField="cod" alignment={'center'} caption={'Codigo'}/>
                            <Column dataField="typeBooking" alignment={'center'} caption={'Tipo de reserva'}/>
                            <Column dataField="driver" alignment={'center'} caption={'Conductor'}/>
                            <Column dataField="routeName" alignment={'center'} caption={'Ruta'}/>
                            <Column dataField="date" alignment={'center'} caption={'Fecha'}/>
                            <Column dataField="hour" alignment={'center'} caption={'Hora'}/>
                            <Column dataField="type" alignment={'center'} caption={'Tipo'}/>
                            <Column dataField="passenger" alignment={'center'} caption={'Pasajero'}/>
                            <Column dataField="numberSeats" alignment={'center'} caption={'Asientos'}/>
                            <Column dataField="numberParcels" alignment={'center'} caption={'Encomiendas'} width={80}/>
                            <Column dataField="status" alignment={'center'} caption={'Estado'}/>
                            <Column type="buttons" width={50}>
                                <Button hint={'Detalle'} onClick={onRowUpdating} icon={'fas fa-edit'}/>
                            </Column>
                        </DataGrid>
                    </FormContainer>
                </div>
            </Animated>

            {bookings?.length === 0 &&
            <LayoutChild percent={95} margin="auto" top={10}>
                <Alerts severity='warning' body={`Aun no existen datos para el mes de ${upperMonth}`}/>
            </LayoutChild>
            }

            <ComponentLoadPanel showLoadPanel={showPanel} messages={textPanel}/>
        </>
    )
}

export default inject('DataStore', 'ControlStore')(observer(BookingHistory));


